// TopStudentsLeaderSkeleton.jsx
import React from "react";
import Skeleton from "../../../CommonComponents/Skeleton";

const TopStudentsLeaderSkeleton = ({ rows = 3 }) => {
  return (
    <div className="tableContainer stripped hoverable">
      <table className="tableSec">
        <thead>
          <tr className="tableHeadRow">
            <th className="tableHead rank">RANK</th>
            <th className="tableHead name">STUDENT NAME</th>
            <th className="tableHead batch">BATCH</th>
            <th className="tableHead score">AVG SCORE</th>
            <th className="tableHead completion">ASSIGNMENT COMPLETION</th>
          </tr>
        </thead>
        <tbody>
          {[...Array(rows)].map((_, idx) => (
            <tr key={idx} className="tableBodyRow">
              {/* RANK column - circular badge */}
              <td className="tableData rank">
                <Skeleton variant="circular" width={40} height={40} />
              </td>

              {/* STUDENT NAME column - avatar + text */}
              <td className="tableData name">
                <div className="student-cell">
                  <Skeleton variant="circular" width={36} height={36} />
                  <Skeleton
                    variant="text"
                    width={120}
                    height={30}
                    style={{ marginLeft: 12 }}
                  />
                </div>
              </td>

              {/* BATCH column */}
              <td className="tableData batch" >
                <Skeleton variant="text" width={80} height={30}  />
              </td>

              {/* AVG SCORE column */}
              <td className="tableData score" >
                <Skeleton variant="text" width={40} height={30}  />
              </td>

              {/* ASSIGNMENT COMPLETION column */}
              <td className="tableData completion" >
                <Skeleton variant="rounded" width={100} height={24} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TopStudentsLeaderSkeleton;